export const config = {
  apiKey: 'AIzaSyCrsXbe95HRHnBCrGpnHIe8wlsNtrMvoNo',
  authDomain: 'waterwatch-cb707.firebaseapp.com',
  databaseURL: 'https://waterwatch-cb707.firebaseio.com',
  projectId: 'waterwatch-cb707',
  storageBucket: 'waterwatch-cb707.appspot.com',
  messagingSenderId: '86550912720'
}



// WEBPACK FOOTER //
// ./src/helpers/firebaseConfig.js